export default __webpack_public_path__ + "static/contact-bg-9fa83b75322c627c0035b06607721ea5.jpg";